// extracted by mini-css-extract-plugin
export default {"docDetails":"attachment_docDetails__LGnIl","docIcon":"attachment_docIcon__W+Avt"};